import {SODeleteDatafeed} from '../../core/datafeed/so-delete-datafeed';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteDatafeed extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteDatafeed;
}